import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "cardBack"
};
const _hoisted_2 = {
  class: "channels-container"
};
const _hoisted_3 = {
  class: "create-channel-container"
};
const _hoisted_4 = {
  class: "dialog-footer"
};
import { computed, onMounted, ref } from 'vue';
import { ElButton, ElInput, ElMessage, ElSelect } from 'element-plus';
import JsonEditorVue3 from 'json-editor-vue3';
import { request } from '@/manager/net_manager';
import store from '@/store';
import ChannelCard from '@/components/Channel/ChannelCard.vue';
import { isAdminType } from '@/tools/utils';
export default {
  __name: 'WOMarketChannel',

  setup(__props) {
    const editorOptions = {
      mode: 'code',
      mainMenuBar: false,
      enableSort: false,
      enableTransform: false,
      language: 'zh-CN',
      schema: {
        type: 'object',
        properties: {
          qualification_logic: {
            type: 'object'
          }
        }
      }
    };
    const models = ['WOOrganization', 'RoleFeats', 'WOQualification']; // refs

    const form = ref({
      name: '',
      qualification_logic: {}
    });
    const createMode = ref(false);
    const model = ref(null);
    const organization = ref(null);
    const qualification = ref(null);
    const marketChannels = ref([]); // computed

    const userType = computed(() => {
      return store.state.user ? parseInt(store.state.user.user_type) : 4;
    });
    const worldOutlook = computed(() => {
      return store.state.world_outlook ? store.state.world_outlook : null;
    });
    const organizations = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.organizations ?? null;
    });
    const qualifications = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.qualifications ?? null;
    }); // functions

    const getData = () => {
      const parameters = {
        'world_outlook_id': store.state.world_outlook.id,
        'is_precis': false
      };
      request('market_channel/market_channels/list/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          marketChannels.value = response.data;
        }
      });

      if (!organizations.value) {
        store.dispatch('get_wo_organizations');
      }

      if (!qualifications.value) {
        store.dispatch('get_wo_qualifications');
      }
    };

    const createChannel = () => {
      let parameters = { ...form.value,
        'world_outlook_id': worldOutlook.value.id
      };
      request('market_channel/market_channels/create/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        form.value = {
          name: '',
          qualification_logic: {}
        };
        createMode.value = false;
        getData();
      });
    };

    const updateChannel = item => {
      let parameters = {
        'channel_id': item.id
      };
      parameters['updates'] = {
        'name': item.name,
        'qualification_logic': item.qualification_logic
      };
      request('market_channel/market_channels/update/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        getData();
      });
    };

    const updateProps = item => {
      let parameters = {
        'channel_id': item.id
      };
      parameters['updates'] = {
        'props': item.props
      };
      request('market_channel/market_channels/update/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        getData();
      });
    };

    const removeChannel = item => {
      let parameters = {
        'channel_id': item.id
      };
      request('market_channel/market_channels/remove/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        getData();
      });
    };

    const closeCreateMode = () => {
      createMode.value = false;
      form.value = {
        name: '',
        qualification_logic: {}
      };
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createVNode(_component_el_row, {
        style: {
          "justify-content": "flex-end"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElButton), {
          onClick: _cache[0] || (_cache[0] = $event => createMode.value = true)
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("新增渠道", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 512), [[_vShow, _unref(isAdminType)(userType.value)]]), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(marketChannels.value, item => {
        return _openBlock(), _createBlock(ChannelCard, {
          key: item.id,
          channel: item,
          models: models,
          onUpdateChannel: updateChannel,
          onRemoveChannel: removeChannel,
          onUpdateProps: updateProps
        }, null, 8, ["channel"]);
      }), 128))]), _createVNode(_component_el_dialog, {
        modelValue: createMode.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => createMode.value = $event),
        title: "创建渠道",
        width: "1300"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_unref(ElButton), {
          onClick: createChannel
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("确认", -1)]))]),
          _: 1
        }), _createVNode(_unref(ElButton), {
          class: "cancel",
          onClick: closeCreateMode
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("取消", -1)]))]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_unref(ElInput), {
          modelValue: form.value.name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.name = $event),
          placeholder: "资格名",
          type: "text",
          "show-word-limit": "",
          clearable: "",
          maxlength: "128"
        }, null, 8, ["modelValue"]), _createVNode(_component_el_row, {
          style: {
            "margin-top": "1.0rem"
          }
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElSelect), {
            modelValue: model.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => model.value = $event),
            "show-arrow": false,
            clearable: "",
            placeholder: "查询模型",
            "popper-class": "commonPopper",
            class: _normalizeClass(model.value ? 'selected-selector' : '')
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(models, (item, index) => {
              return _createVNode(_component_el_option, {
                key: index,
                label: item,
                value: item
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue", "class"]), _createVNode(_unref(ElSelect), {
            modelValue: organization.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => organization.value = $event),
            "show-arrow": false,
            clearable: "",
            placeholder: "查询WO组织",
            "popper-class": "commonPopper",
            class: _normalizeClass(organization.value ? 'selected-selector' : '')
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: `${item.id} - ${item.name}`,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "class"]), _createVNode(_unref(ElSelect), {
            modelValue: qualification.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => qualification.value = $event),
            "show-arrow": false,
            clearable: "",
            placeholder: "查询WO资格",
            "popper-class": "commonPopper",
            class: _normalizeClass(qualification.value ? 'selected-selector' : '')
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qualifications.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: `${item.id} - ${item.name}`,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "class"])]),
          _: 1
        }), _createVNode(_unref(JsonEditorVue3), {
          modelValue: form.value.qualification_logic,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.qualification_logic = $event),
          options: editorOptions
        }, null, 8, ["modelValue"])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};